export function getScreenshotValues(data?: Record<string, string>): string[] {
  if (!data) return [];

  return Object.entries(data)
    .filter(([key]) => key !== "created_at")
    .map(([_, value]) => value);
}
